<template>
  <div
    @click="$emit('click')"
    :style="`background-color:${background}`"
    :class="['payment-getawey', active ? 'active' : '']"
  >
    <img class="logo" :src="logo" alt="" />
    <div :style="`color:${color}`" class="info">
      {{ $t("online_payment.gateways.comission") }}{{ ` ${commision}` }}
    </div>
    <div :style="`color:${color}`" class="info">
      {{ $t(`online_payment.gateways.${getawayTarget}`) }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    background: {
      type: String,
      default: "white",
    },
    commision: {
      type: String,
      default: "2.75%",
    },
    getawayTarget: {
      type: String,
      default: "pb_target",
    },
    logo: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#464646",
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.payment-getawey {
  min-width: 42.333vh;
  border-radius: 1.111vh;
  padding: 2.222vh;
  margin-right: 2.222vh;
  box-sizing: border-box;
  opacity: 0.6;
  cursor: pointer;
}
.logo {
  height: 4.666vh;
  margin-bottom: 2.111vh;
}
.info {
  font-weight: 300;
  font-size: 1.666vh;
  line-height: 2vh;
  margin-bottom: 2.111vh;
  width: 100%;
  white-space: normal;
}
.info:last-child {
  margin-bottom: 0;
}
.active {
  opacity: 1;
}
</style>
